import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row } from 'react-bootstrap';
import { ProjectsTranslations } from './Projects.i18n.ts';
import Project from './components/project/Project.tsx';
import styles from './Projects.module.scss';

const Projects: FC = () => {
    const projectsID: string = "projects";
    
    const {
        t
    } = useTranslation(projectsID);

    const projects: ProjectsTranslations = t('projects', { returnObjects: true });

    return (
        <section
            id={projectsID}
            className={styles.section}
        >
            <div
                className={styles.container}
            >
                <h2
                    className={`text-center ${styles.title}`}
                >
                    {t('title')}
                </h2>
                <Container>
                    <Row>
                        {Object
                        .entries(projects)
                        .map(([projectKey, projectData]) => (
                            <Project
                                key={projectKey}
                                projectData={projectData}
                            />
                        ))}
                    </Row>
                </Container>
            </div>
        </section>
    );
}

export default Projects;